/**
 * Un vrai bouton à bascule : toute la ligne se tape, le rail passe au bleu d'action
 * quand c'est allumé. Le drapeau qu'il porte — une séance importante, une famille du
 * cabinet — ne change jamais ce que la séance vaut ; il dit seulement un fait.
 */
export function Switch({
  label,
  hint,
  value,
  onChange,
}: {
  label: string;
  hint: string;
  value: boolean;
  onChange: (value: boolean) => void;
}) {
  return (
    <label className={`switch${value ? ' is-on' : ''}`}>
      <span className="switch__text">
        <span className="switch__label">{label}</span>
        <span className="hint">{hint}</span>
      </span>
      <input
        type="checkbox"
        role="switch"
        aria-checked={value}
        checked={value}
        onChange={(event) => onChange(event.target.checked)}
      />
      <span className="switch__track" aria-hidden="true">
        <span className="switch__knob" />
      </span>
    </label>
  );
}
